import dynamic from 'next/dynamic';
import type { PortalProps } from '@/components/layout/Portal';

export const DynamicPortal = dynamic<PortalProps>(() => import('@/components/layout/Portal'), {
  ssr: false,
});
